import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll80OWRvaWEwIHsKICBwb3NpdGlvbjogcmVsYXRpdmU7Cn0';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll80OWRvaWExIHsKICBwb3NpdGlvbjogYWJzb2x1dGU7Cn0';
export var BasicUrlEditorContainer = '_49doia0';
export var UrlPreviewContainer = '_49doia1';